import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("relative overflow-hidden rounded-lg bg-muted/80 before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-gradient-to-r before:from-transparent before:via-card/70 before:to-transparent", className)}
      {...props} />
  );
}

export { Skeleton }
